// 광고 문의 등 일반 문의 API.
import { apiClient } from "api/client";

/**
 * 배너 광고 문의 전송.
 * 서버는 nodemailer 로 misolutionmi@gmail.com 에 메일을 발송한다.
 * @param {{ company: string, name: string, phone: string, email: string, adType?: string, message: string }} body
 * @returns {Promise<{ success: boolean, error?: string }>}
 */
export async function submitAdInquiryApi(body) {
  try {
    const { data } = await apiClient.post("/post/inquiry/ad", body);
    return data || { success: false };
  } catch (e) {
    return { success: false, error: e?.response?.data?.error || e.message };
  }
}
